/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import InputMask from 'react-input-mask';
import Modal from 'modules/common/components/Modal';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import Select from 'react-select';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import Uploader from 'modules/common/components/Uploader';
import * as action from '../action';
import * as c from '../constant';

function UpdateEmployeeModal({
  profile,
  updateUserManagement,
  getUserManagementList,
  showUserManagement,
  history,
  getRoleList,
  roleList,
  updating,
}) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
    telephone_number: '',
    address: '',
    role_id: '',
  });
  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    email: 'required|email',
    mobile_number: 'required',
    address: 'required',
    role_id: 'required',
  });

  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      photo: profile.attributes.photo || '',
      first_name: profile.attributes.first_name || '',
      last_name: profile.attributes.last_name || '',
      mobile_number: profile.attributes.mobile_number || '',
      telephone_number: profile.attributes.telephone_number || '',
      email: profile.attributes.email || '',
      address: profile.attributes.address || '',
      role_id: profile.included.roles ? profile.included.roles.id : '',
      is_active: 1,
    });
  };
  const handleOnSubmit = e => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        photo: formData.photo.cdnUrl,
      };
      updateUserManagement(profile.id, args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        showUserManagement(profile.id);
        history.push(`/user-management/employees/${_.get(data, 'id')}`);
        // UpdateInfo();
      });
      return;
    }
    updateUserManagement(profile.id, formData, ({ data }) => {
      getUserManagementList();
      setModal({ isOpen: false });
      showUserManagement(profile.id);
      history.push(`/user-management/employees/${_.get(data, 'id')}`);
      // UpdateInfo();
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const roleOptions = roleList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChangePhoto = key => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-4">
            <label className="form-label">
              Profile Photo: {validateForm.renderMessage('photo')}
            </label>
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
            <FilePondSingleUpload onChange={onChangePhoto('photo')} />
          </div>
          <div className='col-8'>
            <div className="row">
              <div className="col-6 form-group">
                <label className="form-label">
                  First Name: {validateForm.renderMessage('first_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="first_name"
                  onChange={onChange}
                  value={_.get(formData, 'first_name')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Last Name: {validateForm.renderMessage('last_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="last_name"
                  onChange={onChange}
                  value={_.get(formData, 'last_name')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Email: {validateForm.renderMessage('email')}
                </label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  onChange={onChange}
                  value={_.get(formData, 'email')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Mobile Number: {validateForm.renderMessage('mobile_number')}
                </label>
                <InputMask
                  className="form-control"
                  mask="999999999999"
                  alwaysShowMask
                  type="text"
                  name="mobile_number"
                  onChange={onChange}
                  value={_.get(formData, 'mobile_number')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Telephone Number: {validateForm.renderMessage('telephone_number')}
                </label>
                <InputMask
                  className="form-control"
                  mask="999-999-9999"
                  alwaysShowMask
                  type="text"
                  name="telephone_number"
                  onChange={onChange}
                  value={_.get(formData, 'telephone_number')}
                />
              </div>
              <div className="col-12 form-group">
                <label className="form-label">
                  Address: {validateForm.renderMessage('address')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="address"
                  onChange={onChange}
                  value={_.get(formData, 'address')}
                />
              </div>
              <div className="col-12 form-group">
                <label className="form-label">
                  Role: {validateForm.renderMessage('role_id')}
                </label>
                <Select
                  styles={customStyle}
                  placeholder="Select Role"
                  value={
                    roleOptions.filter(
                      item => _.get(formData, 'role_id') === _.get(item, 'id')
                    ) || ''
                  }
                  onChange={handleOnChangeSelect('role_id')}
                  options={roleOptions}
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateEmployeeModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  roleList: PropTypes.instanceOf(Array).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateEmployeeModal);
